import React, { Component } from 'react';
import { Row, Table, Form, FormGroup, Input } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'

class BOTechnologyRequests extends Component {
    constructor(props) {
        super(props);
        this.selectorArr = this.props.selector != null && this.props.selector !== '' ? this.props.selector.split('/') : [];
        this.state = {
            data: [],
            sheetData: [],
            selectedEmployeeId: this.selectorArr.length > 0 && this.selectorArr[0] != null ? (this.selectorArr[0]) : 0,
            selectedAssignedEmployeeId: this.selectorArr.length > 1 && this.selectorArr[1] != null ? (this.selectorArr[1]) : 0,
            selectedStatusId: this.selectorArr.length > 2 && this.selectorArr[2] != null ? (this.selectorArr[2]) : 0,
            selectedSortColumnIndex: 5,
            selectedSortAscending: true,
            filters: []
        };
        this.headers = [
            { display: 'Employee', accessors: ['employeeFirstName', 'employeeLastName'], sort: 'alpha', key: 'employeeLastName' },
            { display: 'Team', accessors: ['teamName'], sort: 'alpha', key: 'teamName' },
            { display: 'Client', accessors: ['clientName'], sort: 'alpha', key: 'clientName' },
            { display: 'Request', accessors: ['requestName'], sort: 'alpha', key: 'requestName' },
            { display: 'Priority', accessors: ['priorityName'], sort: 'priority', key: 'priorityId' },
            { display: 'Order', accessors: ['order'], sort: 'numeric', type: 'priority', key: 'order' },
            { display: 'Time Saved Estimate', accessors: ['timeSavedEstimate'], type: 'numeric', sort: 'numeric', key: 'timeSavedEstimate' },
            { display: 'Submitted', accessors: ['timestamp'], type: 'datetime', sort: 'date', key: 'timestamp' },
            { display: 'Client Directed', accessors: ['clientDirectedYesNo'], sort: 'boolean', key: 'clientDirectedYesNo' },
            { display: 'Status', accessors: ['statusName'], sort: 'alpha', key: 'statusName' },
            { display: 'Assigned Employee', accessors: ['assignedEmployeeFirstName', 'assignedEmployeeLastName'], sort: 'alpha', key: 'assignedEmployeeLastName' },
            { display: 'Order Rank', accessors: ['priorityRankName'], sort: 'numeric', key: 'priorityRankId' },
            { display: 'Programming Estimate', accessors: ['timeEstimate'], type: 'numeric', sort: 'numeric', key: 'timeEstimate' },
            { display: 'Completed', accessors: ['completed'], type: 'datetime', sort: 'date', key: 'completed' },
            { display: 'Notes', accessors: ['notes'], sort: 'alpha', key: 'notes' }
        ]
    }

    componentDidMount() {
        this.props.log('BOTechnologyRequests.js/componentDidMount');
        this.onSubmit(() => {
            this.handleSort(this.state.selectedSortColumnIndex);
        });
    }

    handleSort = (colIndex) => {
        this.props.log('BOTechnologyRequests.js/handleSort (colIndex)', colIndex);
        if (!this.headers[colIndex].sort) return;
        this.setState((prevState) => {
            const ascending = (colIndex === prevState.selectedSortColumnIndex) ? !prevState.selectedSortAscending : true;
            return {
                selectedSortColumnIndex: colIndex,
                selectedSortAscending: ascending,
                data: [...prevState.data].sort((a, b) => {
                    const a2 = (this.headers[colIndex].key != null && a[this.headers[colIndex].key] != null) ? a[this.headers[colIndex].key] : '';
                    const b2 = (this.headers[colIndex].key != null && b[this.headers[colIndex].key] != null) ? b[this.headers[colIndex].key] : '';
                    switch (this.headers[colIndex].sort) {
                        case "date":
                            return ascending ? (new Date(a[this.headers[colIndex].key]).getTime()) - (new Date(b[this.headers[colIndex].key]).getTime())
                                : (new Date(b[this.headers[colIndex].key]).getTime()) - (new Date(a[this.headers[colIndex].key]).getTime());
                        case "numeric":
                            return ascending ? a[this.headers[colIndex].key] - b[this.headers[colIndex].key]
                                : b[this.headers[colIndex].key] - a[this.headers[colIndex].key];
                        case "priority":
                            return ascending ? a[this.headers[colIndex].key] - b[this.headers[colIndex].key]
                                : b[this.headers[colIndex].key] - a[this.headers[colIndex].key];
                        default:
                            return ascending ? a2.localeCompare(b2) : b2.localeCompare(a2)
                    }
                })
            }
        })
    }

    onChange = (e, submit) => {
        this.props.log('BOTechnologyRequests.js/onChange (name, value, e, submit)', e.target.name, e.target.value, e, submit);
        e.persist();
        this.setState({
            [e.target.name]: (e.target.value)
        }, () => {
            this.props.changeSelector({ target: { value: String((this.state.selectedEmployeeId) + '/' + (this.state.selectedAssignedEmployeeId) + '/' + (this.state.selectedStatusId)).replace('0/0/0', '') } })
            this.getCSVdata();
            if (submit) this.onSubmit();
        }
        );
    }

    onSubmit = (cb) => {
        this.props.log('BOTechnologyRequests.js/onSubmit');
        fetch('/api/reports/BOTechnologyRequests', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data
                    }, () => {
                        this.getCSVdata()
                        if (cb != null) cb();
                });
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('BOTechnologyRequests.js/getCSVdata');
        const results = [...this.state.data]
            .filter(row => parseInt(this.state.selectedEmployeeId) === 0 || parseInt(this.state.selectedEmployeeId) === parseInt(row.employeeId))
            .filter(row => parseInt(this.state.selectedAssignedEmployeeId) === 0 || parseInt(this.state.selectedAssignedEmployeeId) === parseInt(row.assignedEmployeeId))
            .filter(row => parseInt(this.state.selectedStatusId) === 0 || parseInt(this.state.selectedStatusId) === parseInt(row.statusId))
            .filter(row => this.headers.map((header, headerIndex) => {
                let retBool = true;
                if (this.state.filters[headerIndex] != null && String(this.state.filters[headerIndex]).trim() !== '') {
                    let interiorBool = false;
                    header.accessors.forEach(accessor => {
                        if (String(row[accessor]).toLowerCase().indexOf(String(this.state.filters[headerIndex]).trim()) > -1
                            && row[accessor] != null && row[accessor] !== ''
                        ) interiorBool = true;
                    })
                    if (!interiorBool) retBool = false;
                }
                return retBool;
            }).findIndex(header => !header) > -1 ? false : true)
        let retArray = [
            ['Requestor', 'Assigned', 'Status'],
            [
                document.getElementById('selectedEmployeeId').options[document.getElementById('selectedEmployeeId').selectedIndex].text,
                document.getElementById('selectedAssignedEmployeeId').options[document.getElementById('selectedAssignedEmployeeId').selectedIndex].text,
                document.getElementById('selectedStatusId').options[document.getElementById('selectedStatusId').selectedIndex].text,
            ],
            [],
            [...this.headers].map(header => header.display)];

        results.forEach(row => {
            let rowArray = [];
            this.headers.forEach(field => {
                const tempArray = field.accessors.map(accessor => {
                    let retVal = null;
                    switch (field.type) {
                        case "datetime":
                            retVal = (row[accessor] != null && row[accessor] !== '') ? this.getDate(row[accessor]) + ' ' + this.getTime(row[accessor]) : '';
                            break;
                        default:
                            retVal = row[accessor]
                    }
                    return retVal;
                })
                rowArray.push(tempArray.length >= 2 ? tempArray.join(' ').trim() : tempArray[0])
            })
            retArray.push(rowArray);
        })
        retArray.push([]);
        retArray.push(
            ['Total', '', '', '', '',
                Math.round(results.reduce((prev, next) => prev + (next.timeSavedEstimate != null && !isNaN(next.timeSavedEstimate) ? Number(next.timeSavedEstimate) : 0), 0).toFixed(2) * 100) / 100,
                '', '', '', '', '',
                Math.round(results.reduce((prev, next) => prev + (next.timeEstimate != null && !isNaN(next.timeEstimate) ? Number(next.timeEstimate) : 0), 0).toFixed(2) * 100) / 100,
                '', ''
            ]
        );
        this.props.passData(retArray, "bo-technology-requests-report");
    }

    getDate = (d) => {
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + String(d).substring(0, 4);
    }

    getTime = (isoTime) => {
        var hours = parseInt(new Date(isoTime).toISOString().substring(11, 13), 10),
            minutes = new Date(isoTime).toISOString().substring(14, 16),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + minutes + ' ' + ampm;
    }

    formatCell = (value, type, row) => {
        this.props.info('BOTechnologyRequests.js/formatCell (value,type)', value, type);
        switch (type) {
            case "priority":
                const calcVal = ((value - ((row.priorityId + 100) * 1000)) / 10);
                return calcVal > 0 ? calcVal : '';
            case "datetime":
                return value != null && value !== '' ? this.getDate(value) + ' ' + this.getTime(value) : '';
            default:
                return value;
        }
    }

    onFilter = (e) => {
        this.props.log('BOTechnologyRequests.js/filterData (e)', e.target.name, e.target.value);
        this.setState((prevState) => {
            let obj = { ...prevState }
            obj.filters[e.target.name.split('_')[1]] = e.target.value;
            return obj;
        },this.getCSVdata)
    }

    render() {
        this.props.info('BOTechnologyRequests.js/render');
        const filteredArray = [...this.state.data]
            .filter(row => parseInt(this.state.selectedEmployeeId) === 0 || parseInt(this.state.selectedEmployeeId) === parseInt(row.employeeId))
            .filter(row => parseInt(this.state.selectedAssignedEmployeeId) === 0 || parseInt(this.state.selectedAssignedEmployeeId) === parseInt(row.assignedEmployeeId))
            .filter(row => parseInt(this.state.selectedStatusId) === 0 || parseInt(this.state.selectedStatusId) === parseInt(row.statusId))
            .filter(row => this.headers.map((header, headerIndex) => {
                let retBool = true;
                if (this.state.filters[headerIndex] != null && String(this.state.filters[headerIndex]).trim() !== '') {
                    let interiorBool = false;
                    header.accessors.forEach(accessor => {
                        if (String(row[accessor]).toLowerCase().indexOf(String(this.state.filters[headerIndex]).trim()) > -1
                            && row[accessor] != null && row[accessor] !== ''
                        ) interiorBool = true;
                    })
                    if (!interiorBool) retBool = false;
                }
                return retBool;
            }).findIndex(header => !header) > -1 ? false : true)
        return (
            <>
                <Row className='py-3'>
                    <Form inline>
                        <FormGroup className='mr-2 mb-2'>
                            <Input type="select"
                                name="selectedEmployeeId"
                                id="selectedEmployeeId"
                                onChange={(e) => this.onChange(e)}
                                value={this.props.isFieldNull(this.state.selectedEmployeeId)}
                            >
                                <option value="0">ALL REQUESTORS</option>
                                {
                                    [...new Set([...this.state.data]
                                        .filter(row => row.employeeId != null)
                                        .map(row => { return JSON.stringify({ name: row.employeeLastName + ', ' + row.employeeFirstName, employeeId: row.employeeId }) }))]
                                        .map(row => JSON.parse(row))
                                        .sort((a, b) => a.name.localeCompare(b.name))
                                        .map(employee => (
                                            <option
                                                key={"employee_" + employee.employeeId}
                                                value={this.props.isFieldNull(employee.employeeId)}
                                            >{employee.name}</option>
                                        ))
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup className='mr-2 mb-2'>
                            <Input type="select"
                                name="selectedAssignedEmployeeId"
                                id="selectedAssignedEmployeeId"
                                onChange={(e) => this.onChange(e)}
                                value={this.props.isFieldNull(this.state.selectedAssignedEmployeeId)}
                            >
                                <option value="0">ALL ASSIGNED</option>
                                {
                                    [...new Set([...this.state.data]
                                        .filter(row => row.assignedEmployeeId != null)
                                        .map(row => { return JSON.stringify({ name: row.assignedEmployeeLastName + ', ' + row.assignedEmployeeFirstName, employeeId: row.assignedEmployeeId }) }))]
                                        .map(row => JSON.parse(row))
                                        .sort((a, b) => a.name.localeCompare(b.name))
                                        .map(employee => (
                                            <option
                                                key={"assignedEmployee_" + employee.employeeId}
                                                value={this.props.isFieldNull(employee.employeeId)}
                                            >{employee.name}</option>
                                        ))
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup className='mr-2 mb-2'>
                            <Input type="select"
                                name="selectedStatusId"
                                id="selectedStatusId"
                                onChange={(e) => this.onChange(e)}
                                value={this.props.isFieldNull(this.state.selectedStatusId)}
                            >
                                <option value="0">ALL STATUSES</option>
                                {
                                    [...new Set([...this.state.data]
                                        .filter(row => row.statusId != null)
                                        .map(row => { return JSON.stringify({ name: row.statusName, statusId: row.statusId }) }))]
                                        .map(row => JSON.parse(row))
                                        .sort((a, b) => (a.name != null ? a.name : '').localeCompare((b.name != null ? b.name : '')))
                                        .map(status => (
                                            <option
                                                key={"status_" + status.statusId}
                                                value={this.props.isFieldNull(status.statusId)}
                                            >{status.name}</option>
                                        ))
                                }
                            </Input>
                        </FormGroup>
                    </Form>
                </Row>
                {/* {filteredArray.length > 0 ? */}
                <Row>
                    <Table>
                        <thead>
                            <tr>
                                {this.headers.map((header, headerIndex) => (
                                    <th
                                        onClick={() => this.handleSort(headerIndex)} className={header.sort !== false ? 'pointer' : ''}
                                        key={header.display}>
                                        {header.display}
                                        <span className={"chevron mr-2 " + (headerIndex === this.state.selectedSortColumnIndex ? "text-info" : "text-white")}><FontAwesomeIcon icon={this.state.selectedSortAscending ? faChevronUp : faChevronDown} /></span>
                                        <Input
                                            name={"header_" + headerIndex}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={(e) => { e.stopPropagation(); this.onFilter(e) }}
                                        />
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {[...filteredArray].map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {this.headers.map(header => (
                                        <td key={header.display}>{header.accessors.map(accessor => this.formatCell(row[accessor], header.type, row)).join(' ')}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className='font-weight-bold'>
                                <td>Total</td>
                                <td colSpan={5}></td>
                                <td>{filteredArray.reduce((prev, next) => prev + (next.timeSavedEstimate != null && !isNaN(next.timeSavedEstimate) ? Number(next.timeSavedEstimate) : 0), 0).toFixed(2)}</td>
                                <td colSpan={5}></td>
                                <td>{filteredArray.reduce((prev, next) => prev + (next.timeEstimate != null && !isNaN(next.timeEstimate) ? Number(next.timeEstimate) : 0), 0).toFixed(2)}</td>
                                <td colSpan={2}></td>
                            </tr>
                        </tfoot>
                    </Table>
                </Row>
                {/* : <>No results</>} */}
            </>
        )
    }
}

export default BOTechnologyRequests;
